import { FeaturePost } from '../FeaturePosts';

export const milestonesAndStreaks: FeaturePost = {
  id: 'milestones-and-streaks',
  image: `${process.env.PUBLIC_URL}/assets/features/milestones-and-streaks.png`,
  screenshot: true,
  cardImage: `${process.env.PUBLIC_URL}/assets/features/milestones-and-streaks-card.png`,
  tag: 'Tracking',
  date: '2026-10-20',
  title: 'Milestones & Streaks',
  subtitle: 'Celebrate the small wins in your health journey',
  readTime: '2 min',
  content: `Tracking your health every day takes effort, and that effort deserves to be celebrated 🎉

#### What it does

- **Streaks** count how many days in a row you've logged in Toastie
- **Milestones** mark moments like your first entry or your first doctor summary
- A little toast notification pops up when you reach one

#### Why we built it

Consistent tracking is what makes patterns visible. Milestones and streaks make it a bit more fun to keep going, especially on the hard days.`,
};
